var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBidsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 2.84209L5.50371 0.863686C5.70157 0.665827 5.70157 0.346252 5.50371 0.148394C5.30585 -0.0494645 4.97108 -0.0494645 4.78842 0.148394L2.81001 2.14204C2.61216 2.3399 2.61216 2.67467 2.81001 2.85733C2.99268 3.03993 3.32752 3.05519 3.52531 2.84213V2.84209Z",
    fill: "#6C6C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30597 5.35318C5.50383 5.55104 5.8234 5.55104 6.02126 5.35318L8.01491 3.35954C8.21277 3.16168 8.21277 2.8421 8.01491 2.64424C7.81705 2.44639 7.48228 2.44639 7.29962 2.64424L5.32121 4.63789C5.09294 4.83575 5.10815 5.15533 5.30601 5.35318H5.30597Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72266 3.08551L5.07715 4.44001C5.07715 4.42481 5.09236 4.42481 5.09236 4.42481L7.08601 2.43116L5.73151 1.07666L3.73786 3.07031C3.73786 3.07031 3.72266 3.07031 3.72266 3.08551Z",
    fill: "#6C6C6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81426 3.60303L0.2074 7.01205C-0.066545 7.2708 -0.0665451 7.69694 0.192196 7.9556C0.466141 8.22955 0.892278 8.21436 1.13575 7.9404L4.54477 4.31829L3.81426 3.60303Z",
    fill: "#6C6C6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86436 7.14897V7.42292H4.65129C4.40782 7.42292 4.20996 7.62077 4.20996 7.86424V8.25996H9.43004V7.86424C9.43004 7.62077 9.23218 7.42292 8.98871 7.42292H8.77564V7.14897C8.77564 6.9055 8.57778 6.70764 8.33431 6.70764H5.30572C5.06225 6.70764 4.86439 6.90543 4.86439 7.14897H4.86436Z",
    fill: "#6C6C6C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58213 8.57959H4.02718C3.93589 8.57959 3.875 8.64048 3.875 8.73177C3.875 8.82306 3.93589 8.88395 4.02718 8.88395H9.58213C9.67343 8.88395 9.73431 8.82307 9.73431 8.73177C9.73431 8.64048 9.67343 8.57959 9.58213 8.57959Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidsDark);
export default __webpack_public_path__ + "static/media/bids-dark.5878abb91862e8ce65dd137a27ead92f.svg";
export { ForwardRef as ReactComponent };